/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const AirplaneCircleSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm5.073-14.907a.73.73 0 0 0-.948-.078c-.47.342-1.156.865-1.585 1.294l-1.243 1.243-6.19-1.082a.313.313 0 0 0-.275.088l-.45.45a.31.31 0 0 0 .094.506l4.793 2.066-2.256 2.256-1.467-.484a.313.313 0 0 0-.319.076l-.464.464a.31.31 0 0 0 .058.487l1.856 1.11 1.11 1.855a.31.31 0 0 0 .486.058l.464-.464a.313.313 0 0 0 .077-.319l-.485-1.467 2.256-2.256 2.067 4.793a.31.31 0 0 0 .505.095l.45-.45a.313.313 0 0 0 .088-.276l-1.082-6.19 1.243-1.242c.43-.43.952-1.117 1.294-1.586a.73.73 0 0 0-.077-.947Z" /></svg>);
const AirplaneCircleSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={AirplaneCircleSolidBase} {...rest} ref={ref} />);
export default AirplaneCircleSolid;